import { SwipeableDrawer } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FaXMarkLightSvgIcon } from '../../../assets/icons/svgs';
import { RootState } from '../../../redux/store';
import { colors } from '../../../theme/colors';
import {
  flexCenteredContentContainerStyles,
  flexCenteredParentContainerStyles,
} from '../../../theme/containers';
import spacing, { isMobileScreen } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import DrawerCloseTopLeftButton from '../../Modals/Drawers/DrawerCloseTopLeftButton';
import DrawerPuller from '../../Modals/Drawers/DrawerPuller';
import useDrawerOpenClose from '../../Modals/Drawers/hooks/useDrawerOpenClose';
import {
  DRAWER_TRANSITION,
  DRAWER_TRANSITION_DURATION,
} from '../../Modals/Drawers/utils';
import ModalBigTitleBar from '../../Modals/ModalBigTitleBar';
import {
  drawerFromBottomPaperFullHeightStyles,
  modalCloseIconStyle,
  modalPaperRootBackdropStyles,
} from '../../Modals/utils';
import AddAnotherLocationButton from '../AddAnotherLocationButton';
import { useLocationSelectorContext } from '../LocationSelectorContext';
import LocationInfo from './LocationInfo';
import LocationSelectItem from './LocationSelectItem';

const LocationSelectorModal = () => {
  const { t, i18n } = useTranslation();

  const {
    isChangeLocationModalOpen,
    setIsChangeLocationModalOpen,
    setIsAddNewLocationModalOpen,
    setIsRemoveLocationModalOpen,
    selectedLocation,
  } = useLocationSelectorContext();

  const isOpen = isChangeLocationModalOpen;
  const onAddNewOpenLocation = () => setIsAddNewLocationModalOpen(true);
  const onShowLocationRemoval = () => setIsRemoveLocationModalOpen(true);
  const handleClose = () => setIsChangeLocationModalOpen(false);

  const { isDrawerOpen, setDrawerToClose, drawerOpacity } = useDrawerOpenClose({
    isOpen,
    handleManualClose: handleClose,
  });

  const LocationsList = () => {
    const userLocations = useSelector(
      (state: RootState) => state.user.locations,
    );

    const { onLocationSelect } = useLocationSelectorContext();

    return (
      <div
        style={{
          width: '100%',
        }}
      >
        {userLocations.map((location) => {
          return (
            <LocationSelectItem
              key={location.id}
              location={location}
              onSelection={onLocationSelect}
              handleModalClose={handleClose}
              selectedLocation={selectedLocation}
            />
          );
        })}
      </div>
    );
  };

  return (
    <>
      <SwipeableDrawer
        onClose={setDrawerToClose}
        anchor="bottom"
        onOpen={() => console.log('')}
        open={isDrawerOpen}
        transitionDuration={DRAWER_TRANSITION_DURATION}
        disableBackdropTransition
        sx={{
          opacity: drawerOpacity,
          transition: DRAWER_TRANSITION,
          '& .MuiPaper-root': {
            ...drawerFromBottomPaperFullHeightStyles,
          },
          '& .MuiBackdrop-root': {
            ...modalPaperRootBackdropStyles,
            pointerEvents: isDrawerOpen ? 'auto' : 'none',
          },
        }}
      >
        {isDrawerOpen && (
          <>
            <DrawerCloseTopLeftButton />
            <FaXMarkLightSvgIcon
              onClick={setDrawerToClose}
              className="onClickEffect"
              size={fontSize['2xl']}
              style={{
                ...modalCloseIconStyle,
                visibility: isMobileScreen ? 'hidden' : 'visible',
                animation: 'fadeInOnRender 2.5s',
              }}
            />
          </>
        )}

        <DrawerPuller
          onClose={setDrawerToClose}
          isFullHeightDrawer={true}
          fullHeightContainerHeight={36}
        />

        <ModalBigTitleBar
          onModalClose={setDrawerToClose}
          title={`${t('location.location')}`}
        />

        <div
          style={{
            ...flexCenteredParentContainerStyles,
            padding: spacing.medium,
            backgroundColor: colors.backgroundMedium,
          }}
        >
          <div style={flexCenteredContentContainerStyles}>
            <LocationsList />
            <AddAnotherLocationButton
              onAddNewOpenLocation={onAddNewOpenLocation}
              onShowLocationRemoval={onShowLocationRemoval}
            />

            <div
              style={{
                width: '100%',
                marginTop: spacing.xl,
                textAlign: 'center',
              }}
            >
              <LocationInfo />
            </div>
          </div>
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default LocationSelectorModal;
